(function(){
  const $list = $('.js-homepage-posts-row');
  $('.js-load-more-posts').click(function(e){
    e.preventDefault();
    const url = window._ajax_url;
    const offset = $('.post__card').length;
    const $btn = $(this);
    $btn.prop('disabled', true);
    $btn.addClass('loading');
    $.ajax({
      type : "get",
      dataType : "json",
      contentType: "application/json",
      url,
      data: {
        action: "load_more_posts",
        offset,
        term: $btn.data('term'),
        lang: $('html').attr('lang')
      },
      success: (res) => {
        if(!res.success) return;
        const { html, has_more } = res.data;
        if(!has_more){
          $('.btn__more__container').hide();
        }
        if(html){
          $list.append(html);
        }
        $btn.prop('disabled', false);
        $btn.removeClass('loading');
      },
      error: (err) => {
        console.log(err);
        $btn.prop('disabled', false);
        $btn.removeClass('loading');
      }
    });
  });
})();